import RandingStyle1 from "../../randing/RandingStyle1";

function Randing017({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_01.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_03.jpg`} // 스텝 변경되는 이미지
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_02.jpg`}
      numberColor="#201c54"
      qOptionColor="blue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_04.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_06.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing017;
